module.exports = __webpack_public_path__ + "static/media/singe.bc6387b6.png";